import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Sheet,
  Link as JoyLink,
  Button
} from '@mui/joy';
import { supabase } from '../supabaseClient';

const Links = () => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    const fetchLinks = async () => {
      const { data, error } = await supabase
        .from('quick_links')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching links:', error);
      } else {
        setLinks(data);
      }
    };

    fetchLinks();
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      
      {links.length > 0 ? (
        links.map((link) => (
          <Box
            key={link.id}
            sx={{
              p: 2,
              borderRadius: 'md',
              bgcolor: 'background.level2',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            <Typography level="body-md" sx={{ fontWeight: 'md' }}>
              {link.title}
            </Typography>
            <JoyLink
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              level="body-sm"
              sx={{ wordBreak: 'break-all', color: 'primary.500' }}
            >
              {link.url}
            </JoyLink>
          </Box>
        ))
      ) : (
        <Typography textAlign="center">No links available.</Typography>
      )}
    </Box>
  );
};

export default Links;